import { ConfigService } from './../../../shared/config';
import { IntegrationService } from './../../../shared/integration.service';
import { Component, OnInit } from '@angular/core';
import { CompanysitesService } from '../company-sites.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { CommonPopup } from '../../common-popup/common-popup';
import { openSystemConfigPopup } from '../system-config-popup';
import { map, flatMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { environment } from 'src/environments/environment';
import { SystemService } from '../../../services/system.service';
import * as CryptoJS from 'crypto-es';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-detail-site',
  templateUrl: './detail-site.component.html',
  styleUrls: ['./detail-site.component.css']
})
export class DetailSiteComponent {

  siteId: string
  // siteElement
  systems$: Observable<{}>;
  // user: User;
  actionButtons: any[];
  user: User;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private siteService: CompanysitesService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private config: ConfigService,
    private systemService : SystemService,
    private http : HttpClient,
    public auth: AuthService,
    public dialog: MatDialog) {


    this.systems$ = this.route.params.pipe(map(params => {
      this.siteId = params['siteId']
    
      return params['siteId'];
    })).pipe(flatMap(siteId => this.siteService.getSiteSystemsByIdObs(siteId))).pipe(map(doc => {
      return doc.map(d => {
        return {
          ...d,
          url: d.url,
          uid: d['systemId']
        }
      })
    }))
    let urlQrcoe = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${environment.appUrl}/init-company?companyId=${this.config.getCompanyId()}%26siteId=${this.siteId}%26systemId=`;
    let url = `${environment.appUrl}/init-company?companyId=${this.config.getCompanyId()}&siteId=${this.siteId}&systemId=`;
    this.actionButtons = [
      { icon: 'dashboard', tooltip: 'Show inventory management', relativeUrl: 'inventory/extra-stockcontroll' },
      { icon: 'qr_code_2', tooltip: 'QRCODE', url: "https://admin.friggkantine.no/poster?systemId=" },
      { icon: 'link', tooltip: 'Link', url: url },

      // { icon: 'list', tooltip: 'Show transactions', relativeUrl: 'records/transactions' }
      // { icon: 'list', tooltip: 'Show records', relativeUrl: 'records' }
    ]


  }

  onDeleteSystem($event) {
    // let event = $event.$event;
    // let systemId = $event.uid
    // event.stopPropagation();


    // const dialogRef = this.dialog.open(DialogDelete, {
    //   disableClose: true,
    //   width: '350px',
    //   data: {
    //     formData: {
    //       title: "DELETE",
    //       message: " Are you sure to continue? "
    //     }
    //   }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.integrationService.deleteFromSystemId(systemId);
    //     this.siteService.onDeleteSystem(systemId, this.siteId)
    //     this.router.navigate(['dashboard/sites', this.siteId])
    //   }
    // });
  }

  async onAddNewSystem() {
    const nextNumber = await this.siteService.getNextSystemNumber();
    const inputFeilds = this.newSystemFields(nextNumber);
    // Every Yes/No select defaults to Yes.
    inputFeilds.forEach(f => {
      if (f.value === undefined && f.selectOptions?.some(o => o.value === true)) f.value = true;
    });
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: "",
        formData: {
          title: "Add System",
          inputFeilds,
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.siteService.onSystemAddNew(result.value, this.siteId);
      }
    });
  }

  private newSystemFields(nextNumber: number | null): any[] {
    return [
            {
              labelName: "Nummer",
              name: "number",
              required: true,
              value: nextNumber,
              type: "number",
              specialText: ""
            },
            {
              labelName: "System Name",
              name: "name",
              required: true,
              type: "text",
              specialText: ""
            },
            {
              labelName: "Description",
              name: "description",
              required: false,
              type: "text",
              specialText: ""
            },
            {
              labelName: "IP",
              name: "ip",
              required: true,
              value: "10.9.0.254",
              type: "text",
              specialText: ""
            },
            {
              labelName: "Need Login",
              name: "needLogin",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Credit Active",
              name: "isCreditActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            },
            {
              labelName: "Group Subsidy",
              name: "isGroupSubsidyActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            },
            {
              labelName: "Garantiomsetning",
              name: "garantiomsetning",
              required: false,
              type: "number",
              specialText: ""
            },
            {
              labelName: "Overall Subsidy",
              name: "subsidy",
              required: true,
              type: "number",
              specialText: ""
            }, {
              labelName: "MVA",
              name: "isMVAActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Vipps type",
              name: "vippsType",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Real",
                  value: "REAL"
                },
                {
                  label: "Demo",
                  value: "DEMO"
                }
              ]
            },
            {
              labelName: "Pay with Vipps",
              name: "isVippsActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Pay with Card",
              name: "isCardActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Guest Mode",
              name: "isGuestModeActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Min. Temp",
              name: "minThresholdTemp",
              required: true,
              type: "number",
              specialText: "",
            },
            {
              labelName: "Max. Temp",
              name: "maxThresholdTemp",
              required: true,
              type: "number",
              specialText: "",
            }, {
              labelName: "Halal Logo Active",
              name: "isHalalLogoActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "New Logo Active",
              name: "isNewLogoActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Vegetar Logo Active",
              name: "isVegeterianLogoActive",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Active Kantine",
              name: "kantineAvailble",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "CheckStatus",
              name: "checkStatus",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Yes",
                  value: true
                },
                {
                  label: "No",
                  value: false
                }
              ]
            }, {
              labelName: "Unavailable Message",
              name: "unavailableMessage",
              required: false,
              type: "text",
              specialText: ""
            }
            , {
              labelName: "WindowMessage",
              name: "windowMessage",
              required: false,
              type: "text",
              specialText: ""
            }, {
              labelName: "Popup Type",
              name: "popupType",
              required: true,
              type: null,
              value: "warning",
              specialText: "",
              selectOptions: [
                {
                  label: "Warning",
                  value: "warning"
                },
                {
                  label: "Info",
                  value: "info"
                },
                {
                  label: "Alert",
                  value: "alert"
                }
              ]
            }, {
              labelName: "Window Color",
              name: "windowColor",
              required: false,
              type: "color",
              value: "#f59e0b",
              specialText: ""
            }

    ];
  }

  onUpdateSystem($event) {
    $event.$event.stopPropagation();
    openSystemConfigPopup(this.dialog, this.siteService, this.siteId, $event.uid);
  }

  // onSystemTransaction(systemId, event) {
  //   event.stopPropagation();
  //   this.router.navigate(['/dashboard/sites', this.siteId, 'system', systemId, 'transaction'])

  encryptData(data) {

    try {
      return CryptoJS.default.AES.encrypt(JSON.stringify(data), environment.encryptSecretKey).toString();
    } catch (e) {
      console.log(e);
      return e
    }
  }

}

